<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <!-- 移动端侧边栏遮罩，点击关闭 -->
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="mobile-sidebar-overlay"
      @click="handleOverlayClick"
    ></div>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>
<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],

  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },

  data() {
    return {}
  },

  methods: {
    handleOverlayClick() {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
@import "src/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100vh;
  width: 100%;
  background: $bodyBg;
  overflow: hidden;
}

.main-container {
  padding: 20px;
  /* 主容器高度占满全部视口，内部自行滚动 */
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.3);
    border-radius: 4px;

    &:hover {
      background: rgba(102, 126, 234, 0.5);
    }
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
}

/* 移动端遮罩层
   - 从顶部全覆盖（sidebar 本身从 top:0 开始，z-index 1001 盖住遮罩）
   - 去掉 backdrop-filter，避免部分移动端浏览器渲染异常
*/
.mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
}

/* 移动端内边距收紧 */
@media screen and (max-width: 768px) {
  .main-container {
    padding: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue